import React from "react";
import Select from "react-select";
import { criminalOptions, groupedOptions, locationOptions,groupBadgeStyles, groupStyles } from "../../data";
import makeAnimated from "react-select/animated";


const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

const animatedComponents = makeAnimated();

export default function ExperienceAndLocation({userExperience, setUserExperience}) {

  const onChangeHandlerMainExp = selectedOption => {
    setUserExperience({...userExperience,["mainExperience"]: selectedOption.value});
  }
  const onChangeHandlerSecondExp = selectedOptions => {
    let selectedOptionsArray = []
    selectedOptions.forEach( selectedOption => 
    selectedOptionsArray.push(selectedOption.value)
  );
    setUserExperience({...userExperience,["secondaryExperience"]: selectedOptionsArray});
  }
  const onChangeHandlerMainLocation = selectedOption => {
    setUserExperience({...userExperience,["mainLocation"]: selectedOption.value});
  }
  const onChangeHandlerSecondLocation = selectedOptions => {
    let selectedOptionsArray = []
    selectedOptions.forEach( selectedOption => 
    selectedOptionsArray.push(selectedOption.value)
  );
    setUserExperience({...userExperience,["secondaryLocation"]: selectedOptionsArray});
  }
  return (
    <div>
      <div className="header-and-save">
        <h3>תחומי התמחות ואזורי התמחות</h3>
      </div>
      <div className="update-page-experience">
        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="main-experience">
            :תחום התמחות עיקרי
          </label>
          <Select
            defaultValue={criminalOptions[5]}
            options={groupedOptions}
            formatGroupLabel={formatGroupLabel}
            placeholder="בחר"
            onChange={onChangeHandlerMainExp}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label
            className="profile-update-label"
            htmlFor="secondary-experience"
          >
            :תחום התמחות נוסף
          </label>
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            isMulti
            options={groupedOptions}
            formatGroupLabel={formatGroupLabel}
            placeholder="בחר"
            onChange={onChangeHandlerSecondExp}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="main-location">
            :אזור התמחות עיקרי
          </label>
          <Select options={locationOptions} placeholder="בחר" 
            onChange={onChangeHandlerMainLocation}
          />
        </div>

        <div className="profile-update-labelinput-wrapper">
          <label className="profile-update-label" htmlFor="secondary-location">
            :אזור התמחות משני
          </label>
          <Select
            closeMenuOnSelect={false}
            components={animatedComponents}
            isMulti
            options={locationOptions}
            placeholder="בחר"
            onChange={onChangeHandlerSecondLocation}
          />
        </div>
      </div>
    </div>
  );
}
